<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-scroll h-wrapper-680">
        <div class="h-dialogContainer">
          <div class="form-group h-col-inputBox">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('System.topoalarmConfig')}}</div>
              <ejs-radiobutton
                    class="h-inputLit"
                    name="runMode"
                    :label="$t('System.yes')"
                    :checked="alarmNumSet"
                    value="1"
                    :change="alarmNumChange"
                  ></ejs-radiobutton>
              <ejs-radiobutton
                    class="h-inputLit"
                    name="runMode"
                    :label="$t('System.no')"
                    :checked="!alarmNumSet"
                    value="0"
                    :change="alarmNumChange"
              ></ejs-radiobutton>
            </div>
          </div>
          <div class="h-bottom-btnBox h-system-btnBox">
            <div class="row">
              <div class="col-md-6 h-col-inputBox">
                <ejs-button cssClass="e-small h-system-personalbtn" :isPrimary="true" @click.native="saveTopoConfig">{{$t('System.save')}}</ejs-button>              
              </div>
            </div>
          </div>
          <div class="b-t"></div>
          <div class="form-group h-col-inputBox"></div>
      
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import { EventBus } from '../../plugins/eventBus';
import mixin from '../../mixin/mixin';

export default {
  name: "topoConfig",
  mixins: [mixin],
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('System.systemManager')}/${this.$t('System.systemSet')}/${this.$t('System.topoConfig')}` },
      dropElement: ".control-fluid",
	    arr: [],
      alarmNumSetValue: 1,
      alarmNumSet:true,
      colorMinor:'',
      colorWarn:'',
      styleColorVar:{},
    };
  },
  components: {
    BasicLayout
  },
  methods: {
    alarmNumChange(args) {
      this.alarmNumSetValue = args.value;
    },
    
    
    queryTopoConfig(){
      const url = "";
      this.axios.get(`/lte/ems/sysmanager/systemtopoconfig/querySystemTopoConfig`).then(response => {
        if (response && response.status === 200) {
          if(0==response.data.resultVal[0].alarmNumSet){
            this.alarmNumSet = false;
          }else{
            this.alarmNumSet = true;
          }
        }
      })
    },
    saveTopoConfig() {
      const url = "/lte/ems/sysmanager/systemtopoconfig/updateSystemTopoConfig";
      // let formData = {"alarmNumSet":this.alarmNumSetValue};
      let formData = new FormData();
      formData.append("alarmNumSet", this.alarmNumSetValue);
      this.axios.post(url, formData).then(response => {
        if(response.status == 200 && response.data){
          EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
        }else{
          EventBus.$emit('toast', {type: 'error', content: `${this.$t('Common.tips.failure')}`});
        }
      });
    },
    
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    removeImage() {
      document.getElementById("dropArea").style.display = "none";
      const element = document.getElementsByClassName('e-file-remove-btn')[0];
      element.click();
    },
    uploadFile(file){
      // console.log("uploadFile",file);
      this.$layer.confirm({
        msg: `${this.$t('System.uploadConfirm')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.confirm')}`,
          func: () => {
            const url = "/lte/ems/fm/alarmpresent/uploadFile";
            let formData = new FormData();
            formData.append("file", file.rawFile);
            const config = {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            };
            this.axios.post(url, formData, config).then(response => {
              if(response.status == 200 && response.data.errorCode == 'SUCCESS'){
                EventBus.$emit('toast', {type: 'success', content: `${this.$t('System.uploadSuccess')}`});
                let imgURL = this.getObjectURL(file.rawFile);
                // console.log(file.rawFile.name);
                console.log(response.data.resultVal);
                localStorage.setItem('alarmsound',"/audios/"+response.data.resultVal);
                // if (imgURL) {
                //   document.getElementById("imgShow").src = imgURL;
                // }
                // document.getElementById("dropArea").style.display = "block";
              }else{
                EventBus.$emit('toast', {type: 'success', content: `${this.$t('System.uploadFault')}`});
              }
            });
          }
        }
      });
    },
    upFile() {
      document
        .getElementsByClassName("e-file-select-wrap")[0]
        .querySelector("button")
        .click();
      return false;
    }
  },
  mounted() {
	  this.queryTopoConfig();
  }
};
</script>


</style>